import { Navigate, useParams } from "react-router-dom";

export function AppEdit() {
  const { appId } = useParams<{ appId: string }>();
  return <Navigate to={`/apps/${appId}`} replace />;
}
